import { render, staticRenderFns } from "./Comissao.vue?vue&type=template&id=c2fc3e9a&scoped=true&"
import script from "./Comissao.vue?vue&type=script&lang=js&"
export * from "./Comissao.vue?vue&type=script&lang=js&"
import style0 from "./Comissao.vue?vue&type=style&index=0&id=c2fc3e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fc3e9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VContainer,VTab,VTabItem,VTabs,VTabsItems})
